'use client';

import React from 'react';
import Dropdown from '../../common/dropdown';

interface RoleSelectorProps {
  role: 'member' | 'partner' | '';
  onRoleChange: (role: 'member' | 'partner') => void;
  error?: string;
}

export function RoleSelector({ role, onRoleChange, error }: RoleSelectorProps) {
  return (
    <div className="flex flex-col gap-2 mb-4">
      <label htmlFor="role" className="cs-input-field flex items-center justify-between">
        <span>Registration Type:</span>
        <span className="cs-asterisk text-xs">*  Required</span>
      </label>
      <Dropdown
        options={[
          { value: 'member', label: 'Member' },
          { value: 'partner', label: 'Partner' },
        ]}
        defaultValue={role || undefined}
        placeholder="- Select type"
        onChange={(value) => onRoleChange(value as 'member' | 'partner')}
        className={`${role ? 'bg-surface-5' : 'bg-surface-3'} cs-input-field hover:bg-surface-4 touch-manipulation cursor-pointer ${
          error ? 'border-destructive cs-input-ring-error' : ''
        }`}
      />
    </div>
  );
}

